/** @format */

/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

import localize from '../../Global/Localize'
import { getData } from '../../Helpers/webApi'
import SimpleTable from '../Tables/SimpleTable'
import Pager from '../Tables/Pager'
import { batchEntryStatus, discrepancyFilter } from '../../Global/enumeration'
import { formatCurrency, formatDate } from '../../Helpers/formatters'
import DatePicker from '../Date/DatePicker'
import EnumsServerCombo from '../ComboBox/EnumsServerCombo'
import Loader from '../Loaders/Loader'

function CreditBatchDiscrepancyLookup({ displayValue, onSelect }) {
  const [isBusy, setIsBusy] = useState(false)
  const [reqParams, setReqParams] = useState({
    filterText: '',
    pageSize: 10,
    pageIndex: 0,
    status: Object.keys(batchEntryStatus)[0],
    startDate: null,
    dateRequestsFilter: 15,
    endDate: null,
    customDate: false,
    discrepancyFilter: Object.keys(discrepancyFilter)[2],
  })
  const [modalActive, setModalActive] = useState(false)
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [sortedBy, setSortedBy] = useState('')
  const [tableData, setTableData] = useState([])
  const columns = [
    {
      label: localize('createdDate'),
      template: r => formatDate(r.createdDate),
    },
    {
      label: localize('status'),
      template: r => r.statusDescription,
    },
    {
      label: localize('batchNumber'),
      template: r => r.paddedCreditBatchBatchNumber,
    },
    {
      label: localize('creditBatchTotalValue'),
      template: r => formatCurrency(r.creditBatchTotalValue),
    },
    {
      label: localize('creditBatchMonthDescription'),
      template: r => r.creditBatchMonthDescription,
    },
    {
      label: localize('creditBatchReference'),
      template: r => r.creditBatchReference,
    },
    {
      label: localize('column1'),
      template: r => r.column1,
    },
    {
      label: localize('column2'),
      template: r => r.column2,
    },
    {
      label: localize('column3'),
      template: r => r.column3,
    },
    {
      label: localize('column4'),
      template: r => r.column4,
    },
    {
      label: localize('column5'),
      template: r => r.column5,
    },
    {
      label: localize('column6'),
      template: r => r.column6,
    },
    {
      label: localize('column7'),
      template: r => r.column7,
    },
    {
      label: localize('column8'),
      template: r => r.column8,
    },
    {
      label: localize('column9'),
      template: r => r.column9,
    },
    {
      label: localize('column10'),
      template: r => r.column10,
    },
    {
      label: localize('column11'),
      template: r => r.column11,
    },
    {
      label: localize('column12'),
      template: r => r.column12,
    },
    {
      label: localize('column13'),
      template: r => r.column13,
    },
    {
      label: localize('column14'),
      template: r => r.column14,
    },
    {
      label: localize('remarks'),
      template: r => r.remarks,
    },
    {
      label: localize('creditBatchTypeDescription'),
      template: r => r.creditBatchTypeDescription,
    },
    {
      label: localize('creditTypeBatchFileTypeDescription'),
      template: r => r.creditBatchCreditTypeBatchFileTypeDescription,
    },
    {
      label: localize('productCodeDescription'),
      template: r => r.productCodeDescription,
    },
    {
      label: localize('paddedTargetProductCode'),
      template: r => r.paddedTargetProductCode,
    },
    {
      label: localize('createdBy'),
      template: r => r.createdBy,
    },
  ]

  async function loadData() {
    const url = '/lookup/creditBatch/find-credit-batch-discrepancies-in-page'

    const { success, data } = await getData(url, reqParams, false)
    if (success) {
      setIsBusy(false)
      setData(data)
      setTableData(data.pageCollection)
    } else {
      setIsBusy(false)
    }
  }

  function handleSort(column, columnIndex) {
    if (!sortedBy) {
      let sorted = tableData.sort((a, b) => a[column] > b[column])
      setTableData([])
      setTimeout(() => {
        setTableData(sorted)
        setSortedBy([column, 1, columnIndex])
      }, 10)
    } else {
      let sorted = []
      if (sortedBy[1] === 0) {
        sorted = tableData.sort((a, b) => a[column] > b[column])
        setSortedBy([column, 1, columnIndex])
      } else {
        sorted = tableData.sort((a, b) => a[column] < b[column])
        setSortedBy([column, 0, columnIndex])
      }
      setTableData([])
      setTimeout(() => {
        setTableData(sorted)
      }, 10)
    }
  }

  useEffect(() => {
    if (modalActive) loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    reqParams.discrepancyFilter,
    reqParams.pageSize,
    reqParams.pageIndex,
    reqParams.status,
    modalActive,
  ])

  return (
    <>
      <div
        className="form-control d-flex align-items-center"
        style={{
          padding: 0,
          cursor: 'pointer',
          overflow: 'hidden',
          pointerEvents: 'all',
          opacity: 1,
        }}
        onClick={() => setModalActive(true)}
      >
        <div
          style={{
            flex: 1,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            margin: 0,
          }}
          htmlFor=""
          className="ms-2"
        >
          {displayValue}
        </div>
        <button
          className="btn btn-primary"
          style={{ margin: 0, transform: 'scale(0.9)' }}
          onClick={() => setModalActive(true)}
        >
          <i className="uil uil-search"></i>
        </button>
      </div>
      {modalActive && (
        <Modal isOpen className="modal-xl">
          <ModalHeader className="bg-white text-capitalize">
            {localize('creditBatchDiscrepancyLookup')}
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setModalActive(false)}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </ModalHeader>

          <ModalBody className="bg-white p-3">
            {isBusy ? (
              <Loader />
            ) : (
              <>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <label
                      className="text-capitalize"
                      htmlFor="lookupRecordsPerPage"
                    >
                      {localize('recordsPerPage')}
                    </label>
                    <select
                      id="lookupRecordsPerPage"
                      className="form-select ms-3"
                      style={{ width: 'fit-content' }}
                      defaultValue={reqParams.pageSize}
                      onChange={e => {
                        setReqParams({
                          ...reqParams,
                          pageIndex: 0,
                          pageSize: e.target.value,
                        })
                      }}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <div className="d-flex align-items-center">
                    <label className="text-capitalize" htmlFor="batchStatus">
                      {localize('status')}
                    </label>
                    <EnumsServerCombo
                      customContainerStyle={{ width: '100%' }}
                      enumsKey="BatchEntryStatus"
                      value={reqParams?.status}
                      onChange={e => {
                        setReqParams({
                          ...reqParams,
                          pageIndex: 0,
                          status: e.value,
                        })
                      }}
                    />
                  </div>
                  <div className="d-flex align-item-center">
                    <label htmlFor="search" className="me-1 text-capitalize">
                      {localize('dateRange')}
                    </label>
                    <DatePicker
                      onSelect={v => {
                        if (v.custom) {
                          setReqParams({
                            ...reqParams,
                            customDate: true,
                            startDate: v.startDate,
                            endDate: v.endDate,
                            pageIndex: 0,
                          })
                        } else {
                          setReqParams({
                            ...reqParams,
                            customDate: false,
                            dateRequestsFilter: v.value,
                            pageIndex: 0,
                          })
                        }
                      }}
                    />
                  </div>
                  <div className="d-flex align-items-center float-end my-2">
                    <label className="text-capitalize" htmlFor="filterButton">
                      {localize('search')}
                    </label>

                    <div className="d-flex-align-items-center">
                      <EnumsServerCombo
                        customContainerStyle={{ width: '100%' }}
                        enumsKey="DiscrepancyFilter"
                        value={reqParams.discrepancyFilter}
                        onChange={e => {
                          setReqParams({
                            ...reqParams,
                            discrepancyFilter: e.value,
                            pageIndex: 0,
                          })
                        }}
                      />
                    </div>

                    <input
                      type="search"
                      id="search"
                      className="form-control col ms-2"
                      value={reqParams.filterText}
                      onChange={e => {
                        setReqParams({
                          ...reqParams,
                          filterText: e.target.value,
                        })
                      }}
                    />
                    <button
                      id="filterButton"
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        loadData()
                      }}
                    >
                      <i className="uil uil-filter"></i>
                    </button>
                  </div>
                </div>
                <div className=" py-1">
                  <SimpleTable
                    columns={columns}
                    data={tableData}
                    onSelect={r => {
                      setModalActive(false)
                      onSelect(r)
                    }}
                    canSelect
                    onSort={(c, i) => handleSort(c, i)}
                    sortedBy={sortedBy}
                  />
                </div>
                <Pager
                  itemsCount={data.itemsCount}
                  pageSize={reqParams.pageSize}
                  pageIndex={reqParams.pageIndex}
                  pageBatchSize={5}
                  onPageChange={p =>
                    setReqParams({ ...reqParams, pageIndex: p })
                  }
                />
              </>
            )}
          </ModalBody>
          <ModalFooter className="bg-white p-2">
            <button
              className="btn btn-danger  text-capitalize"
              onClick={() => setModalActive(false)}
            >
              {localize('cancel')}
            </button>
          </ModalFooter>
        </Modal>
      )}
    </>
  )
}

export default CreditBatchDiscrepancyLookup
